import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { APP_VERSION } from './config';

// Garantir que APP_VERSION seja incluído no bundle para verificação de versão
// Esta linha garante que o hash do commit seja incluído no bundle compilado
// O uso direto da string garante que o valor seja incluído no bundle JavaScript
if (process.env.NODE_ENV === 'production') {
  // Adicionar versão ao window para debug (opcional)
  // Usar concatenação de string para garantir que o valor seja incluído no bundle
  const versionString = 'version_' + APP_VERSION + '_end';
  (window as any).__APP_VERSION__ = APP_VERSION;
  // Forçar uso da string para evitar tree-shaking
  console.log('App Version:', versionString.replace('version_', '').replace('_end', ''));
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
